import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EditVacationsProposalAction, SEASONS } from '@app/activo2/manage-vacations/manage-vacations.constants';
import { IProposal, IProposalsByOrder } from '@app/activo2/manage-vacations/manage-vacations.interface';
/* eslint-disable @typescript-eslint/naming-convention */

@Component({
  selector: 'app-proposals-actions-card',
  templateUrl: './proposals-actions-card.component.html',
  styleUrls: ['./proposals-actions-card.component.scss']
})
export class ProposalsActionsCardComponent {
  @Input() proposalsByOrder!: IProposalsByOrder;
  @Input() season!: SEASONS;
  @Output() actionClicked: EventEmitter<EditVacationsProposalAction> = new EventEmitter<EditVacationsProposalAction>();

  readonly ACTIONS = EditVacationsProposalAction;

  get orderHasProposals() {
    return this.proposalsByOrder?.proposals?.length;
  }

  onActionClicked(editProposal: EditVacationsProposalAction) {
    if (!this.orderHasProposals && editProposal === this.ACTIONS.EDIT) {
      editProposal = this.ACTIONS.ADD;
    }

    this.actionClicked.emit(editProposal);
  }

  trackByItems(item: IProposal) {
    return item;
  }
}
